export default function menuDropdown() {
    const isMobile = window.matchMedia('only screen and (max-width: 1023px)').matches;

    const menuItem = jQuery('.menu-item-has-children');
    const subMenu = '.sub-menu';

    if (isMobile) {
        menuItem.on('click', function (e) {
            e.preventDefault();
            let clickedSubMenu = jQuery('> ' + subMenu, this);
            jQuery(subMenu).not(clickedSubMenu).slideUp();
            clickedSubMenu.slideToggle();
        });
    } else {
        menuItem
            .on('mouseenter', function () {
                jQuery('> ' + subMenu, this)
                    .stop()
                    .slideDown();
            })
            .on('mouseleave', function () {
                jQuery('> ' + subMenu, this)
                    .stop()
                    .slideUp();
            });
    }
}
